import { render, staticRenderFns } from "./ModalDouble.vue?vue&type=template&id=7c147408&scoped=true&"
import script from "./ModalDouble.vue?vue&type=script&lang=js&"
export * from "./ModalDouble.vue?vue&type=script&lang=js&"
import style0 from "./ModalDouble.vue?vue&type=style&index=0&id=7c147408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c147408",
  null
  
)

export default component.exports